<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="values"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
        >
          <template slot="no-data">
            <span> Nenhum Território </span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              color="primary"
              class="mr-3"
              @click="
                $router.push(
                  `/gestao-territorios/${tabType}/${item.territorioId}/edit`
                )
              "
            >
              Visualizar iniciativa
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { territorioAPI } from "@/modules/gestao-territorios/API/territorioAPI";
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      headers: [
        { text: "Território", value: "nomeFantasia" },
        { text: "Ações", value: "actions" },
      ],
      values: [],
      tabType: this.$route.params.tab,
      search: "",
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    load() {
      this.setLoading(true);
      territorioAPI.list().then(({ data }) => {
        this.values = data;
        this.values = data.map((item) => ({
          ...item,
          inicio: moment(item.inicio).format("DD/MM/YYYY"),
        }));
        this.setLoading(false);
      });
    },
  },

  mounted() {
    this.load();
  },
};
</script>
<style scoped lang="scss">
.col-values {
  display: flex;
  justify-content: flex-end;
}

.share-link {
  background: #5c8bb9 !important;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10%;
  width: 80%;
  .v-icon {
    color: #ffffff !important;
  }

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
      rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
      rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  }
}
</style>
